import React, { FC, useEffect, useRef, useState } from 'react';
import Styles from './StaticProductEntitle.module.scss';
import ToolTip from '../ToolTip/ToolTip';
import RichText from '../richtext';
import { AssetPathPropConfig } from '../../services';
import { Form } from 'react-bootstrap';
import TvOptionsContainer from './TvOptionsContainer';

const StaticProductEntitlement: FC<any> = ({
  content,
  constants,
  showModalPopup,
  setToggleState,
  toggleState,
  noTabs,
  mainContent,
  enableTVStreamingOptions,
  metadata,
  setTvOptionsData
}) => {
  const entitlementSection = useRef<HTMLDivElement>(null);
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
  const titleTV =
    toggleState?.TV && content?.addTV
      ? content?.addedTVTitle
      : toggleState?.Netflix && content?.addNetflix
        ? content?.addedNetflixTitle
        : (content?.addTV || content?.addNetflix) && noTabs
          ? content?.toggleTitle
          : !toggleState?.gigaSpeed && content?.addGigaSpeedToggle
            ? content?.addGigaSpeedToggleTitle
            : toggleState?.gigaSpeed && content?.addGigaSpeedToggle
              ? content?.addedGigaSpeedToggleTitle
              : content?.title;

  return (
    <div>
      <div ref={entitlementSection}>
        <div className={Styles.productdetailswrapper}>
          <div className={Styles.configheadersection} style={{ width: '100%' }}>
            {content?.icon?.filename && (
              <span>
                <img
                  src={content?.icon?.filename}
                  alt='img'
                  width={24}
                  height={24}
                  className={Styles.imagecontainer}
                />
              </span>
            )}

            <span
              className={
                (content?.addTV || content?.addNetflix || content?.addGigaSpeedToggle) && noTabs
                  ? Styles.titlename
                  : Styles.displayname
              }
            >
              {titleTV}
            </span>
            <div className={Styles.tvcontainer}>
              {content?.addTV && content?.TVPrice && noTabs && (
                <span className={Styles.price}>{content?.TVPrice}</span>
              )}
              {content?.addNetflix && content?.NetflixPrice && noTabs && (
                <span className={Styles.price}>{content?.NetflixPrice}</span>
              )}
              {content?.addTV && noTabs && (
                <span className={Styles.toggle}>
                  <Form>
                    <Form.Check
                      type='switch'
                      readOnly={true}
                      checked={toggleState?.TV}
                      onClick={() => {
                        setToggleState({ ...toggleState, TV: !toggleState?.TV, Netflix: false });
                      }}
                    />
                  </Form>
                </span>
              )}
              {content?.addNetflix && noTabs && (
                <span className={Styles.toggle}>
                  <Form>
                    <Form.Check
                      type='switch'
                      readOnly={true}
                      checked={toggleState?.Netflix}
                      onClick={() => {
                        setToggleState({ ...toggleState, Netflix: !toggleState?.Netflix });
                      }}
                    />
                  </Form>
                </span>
              )}

              {content?.addGigaSpeedToggle && noTabs && (
                <span className={Styles.toggle}>
                  <Form>
                    <Form.Check
                      type='switch'
                      readOnly={true}
                      checked={toggleState?.gigaSpeed}
                      onClick={() => {
                        setToggleState({
                          ...toggleState,
                          gigaSpeed: !toggleState?.gigaSpeed,
                          gigaSpeedSelectionTitle:
                            content?.addGigaSpeedToggleAnalyticsTitle || 'Enable 2.5 Gbits Mode'
                        });
                      }}
                    />
                  </Form>
                </span>
              )}
            </div>
            {!content?.addGigaSpeedToggle && content?.tooltip ? (
              <div className={Styles.tooltip} style={{ marginLeft: 'auto' }}>
                <ToolTip content={content?.tooltip} />
              </div>
            ) : null}
          </div>
          <div className={Styles.gigacontainer}>
            {content?.addGigaSpeedToggle && content?.tooltip ? (
              <>
                <div>{content?.title}</div>
                <div className={Styles.bundletooltip} style={{ marginLeft: 'auto' }}>
                  <ToolTip content={content?.tooltip} />
                </div>
              </>
            ) : null}
          </div>
          <div className={Styles.configdetailssection}>
            {content?.channelName && content?.enableTV && (
              <div
                className={Styles.newmodal}
                onClick={() => {
                  showModalPopup();
                }}
              >
                <div className={Styles.tvHeading}>{content?.channelName}</div>

                <div className={Styles.changeBtn}>{constants.changeText}</div>
                <img
                  src={`${assetPath}/icons/chevron-down-red.svg`}
                  height={24}
                  width={24}
                  alt={''}
                />
              </div>
            )}
            {content?.descriptionList && (
              <div id={`entitledespV3`}>
                {content?.descriptionList?.map((item: any, index: number) => (
                  <div key={index} className={Styles.descList}>
                    <RichText content={item?.text} />
                  </div>
                ))}
              </div>
            )}
          </div>
          {(content?.addTV || content?.type === 'tv') && enableTVStreamingOptions && (
            <div className={Styles.TvOptionsection}>
              <TvOptionsContainer
                content={mainContent}
                constants={constants}
                metadata={metadata}
                setTvOptionsData={setTvOptionsData}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaticProductEntitlement;
